import { render, staticRenderFns } from "./LiquidacionProductoTableComponent.vue?vue&type=template&id=6a83d456&"
import script from "./LiquidacionProductoTableComponent.vue?vue&type=script&lang=js&"
export * from "./LiquidacionProductoTableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports